import * as types from '../../mutation-types'
import dashboard from './dashboard'
import manualInvoice from './manualInvoice'
import auth from './auth'
// import travels from './travels'
// import queues from './queues'
import tools from './tools'
// import forms from './forms'
// import settings from './settings'
// import weeks from './weeks'
import monitor from './monitor'
// import openpay from './openpay'
// import users from './users'
// import statistics from './statistics'
import tickets from './tickets'
import ticketsBasic from './ticketsBasic'
// import financial from './financial'
import trips from './trips'
import tripss from './tripsBasic'
import config from './config'
import admin from './admin'
import sharedTrip from './sharedTrip'
// import ui from './ui'
import test from './test'
import padron from './padron'
import padronn from './padronBasic'
import padronnn from './padronAICM'
import employees from './employees'
import driverCard from './driverCard'
import driverCard2 from './driverCard2'
import owner from './owner'
import support from './support'
import aircabReport from './aircabReport'
import callCenter from './callCenter'
import supervisor from './supervisor'
import holder from './holder'
import finanzaporto from './finanzaporto'
import driverpagos from './driverPagos'

const state = {
  items: [
    owner,
    driverCard,
    driverCard2,
    dashboard,
    monitor,
    trips,
    tripss,
    tickets,
    ticketsBasic,
    manualInvoice,
    // forms,
    // statistics,
    // queues,
    // settings,
    padron,
    padronn,
    padronnn,
    aircabReport,
    callCenter,
    employees,
    tools,
    // weeks,
    // financial,
    config,
    support,
    // ui,
    auth,
    test,
    // openpay,
    // users
    admin,
    sharedTrip,
    driverpagos,
    // supervisormonitor,
    supervisor,
    // holdermonitor,
    holder,
    finanzaporto,
  ]
}

const mutations = {
  [types.TOGGLE_EXPAND_MENU_ITEM] (state, payload) {
    let menuItem = payload.menuItem
    let expand = payload.expand
    if (menuItem.children && menuItem.meta) {
      menuItem.meta.expanded = expand
    }
  }
}

const actions = {
  toggleExpandMenuItem ({commit}, payload) {
    commit(types.TOGGLE_EXPAND_MENU_ITEM, payload)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/index.js